<script setup lang="ts">
import type { ImageListItem } from '#shared/types/entity'

import { computed } from 'vue'

import { useActiveCity } from '~/composables/useActiveCity'

// Без кейсов региона (их нельзя заменять работами другого города) вместо блока работ — фото
// сервиса города; если и фото нет, цены занимают всю ширину.
const { data: casesData } = await useCases()
const hasCases = computed<boolean>(() => (casesData.value?.length ?? 0) > 0)

await useCities()
const activeCity = useActiveCity()
const cityId = computed<string | undefined>(() => activeCity.value?.id)
const { data: locationsData } = await useLocations(cityId)

const branchImages = computed<ImageListItem[]>(() =>
  (locationsData.value ?? []).flatMap((location) => location.images ?? [])
)
const branchAddress = computed<string | undefined>(() => locationsData.value?.[0]?.address)
</script>

<template>
  <TwoColumns v-if="hasCases">
    <ServicePriceSection />
    <CaseSection />
  </TwoColumns>
  <TwoColumns v-else-if="branchImages.length > 0">
    <ServicePriceSection />
    <BranchGallery :images="branchImages" :address="branchAddress" more-href="/work" />
  </TwoColumns>
  <ServicePriceSection v-else />
</template>
